import dateFormat from '@/utils/dateformat.js'
export const formatComment = content => {
  if(content.includes('%%}}')) {
    const newContent = content.split('%%}}')
    return newContent && newContent[0]
  }
  return content
}

export const formatAudioTime = time => {
  return dateFormat(time, `M:S`)
}

export const formatAudioPCTime = time => {
  return dateFormat(time, `M'S"`)
}